


























import { Component, Prop, Vue } from "vue-property-decorator";
import { CookieHelper } from "@/helper/cookieHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { UserConfigColors } from "@/userConfigColors/userConfigColors";
import { UserAgentHelper } from "@/helper/userAgentHelper";

import CheckOn from "../resources/checkOn.vue";

@Component({
  components: {
      CheckOn
  }
})

export default class SaveAttentionAlert extends Vue 
{
    // 表示確認用
    private isVisible = false;
    private completion : (() => void) | null = null;
    private title = "ファイル保存時のご注意";
    private static readonly message1_edge = "画面下部に表示される処理から";
    private static readonly message2_edge = "[保存]もしくは[名前を付けて保存]を選択してください。";
    private static readonly message1_default = "ブラウザで保存されたフォルダへ保存されます。";
    private static readonly message2_default = "ブラウザの設定から保存場所、保存方法を変更できます。";
    
    private useEdgeMessage() { return UserAgentHelper.getBrowser() == "ie" || UserAgentHelper.getBrowser() == "edge"; }

    private get message1()
    {
        return this.useEdgeMessage() ? SaveAttentionAlert.message1_edge : SaveAttentionAlert.message1_default;
    }

    private get message2()
    {
        return this.useEdgeMessage() ? SaveAttentionAlert.message2_edge : SaveAttentionAlert.message2_default;
    }

    private ischeck = false;

    public isAvailable()
    {
        return !(CookieHelper.getItem("saveAttentionAlert") === true);
    }

    public open(completion : () => void)
    {
        this.isVisible = true;
        this.completion = completion;
        
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    private onOk()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;

        // クッキーに"表示しない"チェック状態保持
        CookieHelper.setItem("saveAttentionAlert", this.ischeck);

        this.isVisible = false;
        if(this.completion != null) { this.completion(); }
    }

    private getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigButtonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
